<template>
  <PageWrapper :isLoading="isLoading" :hasFilters="true" @submitFilters="fetchData">
    <template #title> آمار فروش درس ها </template>

    <template #filters>
      <RangeDatePicker class="w-24 filters-width" label="بازه‌ی تاریخ فروش درس ها را وارد کنید"
        @getDateRange="setDateRange"></RangeDatePicker>

        <lesson-picker
        class="w-24 filters-width"
                ref="lessonPicker"
                @getLesson="setRoadmapLanguageId"
              ></lesson-picker>

              <LanguagePicker
              placeHolder="نمایش بر اساس زبان"
              @getLanguage="setChartLanguage"
              class="w-24 filters-width"
            ></LanguagePicker>
            <CustomSelect
              class="w-24 filters-width"
          inputLabel="نمایش بر اساس مبلغ"
          :customOptions="objectSortOptions"
          v-model="orderLessonsFilters.sort"
        ></CustomSelect>
    </template>

       <BRow
      class="mb-2"
    >
      <BCol cols="12" class="mb-1">
        <hr />
      </BCol>
      <BCol cols="12" md="4">
        <p>
          مبلغ کل فروش درس ها:
          <span class="text-success">
            {{ Intl.NumberFormat("en-US").format(totalSale) }}
          </span>
          تومان
        </p>
      </BCol>
      <BCol cols="12" md="4">
        <p>
          تعداد فروش کل درس ها:
          <span class="text-warning">
            {{ totalUser }}
          </span>
          نفر
        </p>
      </BCol>
    </BRow>
    <CustomTable v-if="orderLessons" :pageNumber="orderLessonsFilters.pageNumber" :count="orderLessonsFilters.count"
      :totalCount="totalCount" :tableColumns="tableColumns" :tableItems="orderLessons" @changePage="changePage">
      <template #handleAccess="data">
        <BButton size="sm" variant="transparent" @click="getOrderLessonsModal(data)">
          <FeatherIcon class="text-info" icon="MapIcon" size="20" />
        </BButton>
      </template>
    </CustomTable>
    <LessonAnalyticsModal @closeLessonAnalyticModal="closeLessonAnalyticModal" :lessonData="selectedLessonDetail">
    </LessonAnalyticsModal>
  </PageWrapper>
</template>
<script>
export default {
  mounted() {
    this.getOrderLessons();
  },
  data() {
    return {
      isLoading: false,
      totalCount: 0,
      totalUser:null,
      totalSale:null,
      objectSortOptions:[
        {
          value:null,
          text:'همه'
        },
        {
          value:'0',
          text:'بیشترین'
        },
        {
          value:'1',
          text:'کمترین'
        },
      ],
      totalOrderSale: null,
      totalOrderCount: null,
      selectedLessonDetail: null,
      tableColumns: [
        {
          key: "lessonId",
          label: "شناسه",
        },
        {
          key: "lessonName",
          label: "عنوان درس",
        },
        {
          key: "allPrice",
          label: "قیمت کل سفارش",
          formatter: (value) =>
            `${value ? Intl.NumberFormat("en-US").format(value) : "0"} تومان`,
        },
        {
          key: "allPriceAfterDiscunt",
          label: "قیمت کل پرداختی",
          formatter: (value) =>
            `${value ? Intl.NumberFormat("en-US").format(value) : "0"} تومان`,
        },
        {
          key: "allOrderPayd",
          label: "تعداد کل سفارش",
        },
        {
          key: "handleAccess",
          label: "اطلاعات",
        },
      ],
      orderLessonsFilters: {
        pageNumber: 1,
        count: 10,
        lessonId:null,
        lessonId: null,
        startDate: null,
        endDate: null,
      },
      orderLessons: null,
    };
  },
  methods: {
    setRoadmapLanguageId(lessonId) {
      this.orderLessonsFilters.lessonId = lessonId;
    },
    setChartLanguage(languageId) {
      this.orderLessonsFilters.languageId = languageId;
    },
    closeLessonAnalyticModal() {
      this.$nextTick(() => {

        this.$bvModal.hide("lesson-analytic-modal");
      })
    },
    async getOrderLessonsModal(orderData) {
      const _this = this;

      this.selectedLessonDetail = _this.orderLessonsFilters
      this.selectedLessonDetail.lessonId = orderData.item.lessonId
      this.selectedLessonDetail.sort = 0

      this.$bvModal.show("lesson-analytic-modal");
    },


    setDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.orderLessonsFilters.startDate = new Date(
          dateRange[0]
        ).toISOString();
        this.orderLessonsFilters.endDate = new Date(
          dateRange[1]
        ).toISOString();
      } else {
        this.orderLessonsFilters.startDate = null;
        this.orderLessonsFilters.endDate = null;
      }
    },

    changePage(pageNumber) {
      this.orderLessonsFilters.pageNumber = pageNumber;
      this.getOrderLessons();
    },

    async fetchData() {
      this.orderLessonsFilters.pageNumber = 1
      this.getOrderLessons()
    },

    async getOrderLessons() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllOrderLessons = new GetOrderLessons(
          _this
        );
        getAllOrderLessons.setRequestParamDataObj(
          _this.orderLessonsFilters
        );
        await getAllOrderLessons.fetch((response) => {
          if (response.isSuccess) {
            _this.totalCount = response.data.total
            _this.orderLessons = response.data.data
            _this.totalSale=response.data.sum
            _this.totalUser=response.data.sum2
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },

  components: {
    PageWrapper,
    CustomTable,
    RangeDatePicker,
    BRow,
    BCol,
    BLink,
    BButton,
    LessonAnalyticsModal,
    LessonPicker,
    LanguagePicker,
    CustomSelect,
  },
};
import LessonPicker from "@/views/components/Lessons/LessonPicker.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { BRow, BCol, BLink, BButton } from "bootstrap-vue";
import LessonAnalyticsModal from "@/views/components/Lessons/LessonAnalyticsModal.vue";
import { GetOrderLessons, GetOrderLessonsDetails } from "@/libs/Api/Lesson";
</script>
